import { useTranslation } from 'react-i18next';

export default function AlternativeContact() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-10">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('apply.altContact.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('apply.altContact.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('apply.altContact.titleEn')}
          </p>
          <div className="gold-line mx-auto mb-6"></div>
          <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {t('apply.altContact.lead')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div className="bg-background-100/60 border border-background-200/60 p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-line text-accent-500 text-2xl"></i>
            </div>
            <h3 className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium mb-2">
              {t('apply.altContact.phone.title')}
            </h3>
            <a
              href="tel:0368244086"
              className="text-[17px] text-foreground-800 tracking-[0.06em] hover:text-accent-600 transition-colors font-medium"
            >
              03-6824-4086
            </a>
            <p className="text-[13px] text-foreground-400 mt-1.5 tracking-[0.03em]">
              {t('apply.altContact.phone.hours')}
            </p>
          </div>

          <div className="bg-background-100/60 border border-background-200/60 p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-accent-500 text-2xl"></i>
            </div>
            <h3 className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium mb-2">
              {t('apply.altContact.email.title')}
            </h3>
            <a
              href="mailto:info@butler-academy.jp"
              className="text-[16px] text-accent-600 tracking-[0.04em] hover:text-accent-500 transition-colors"
            >
              info@butler-academy.jp
            </a>
            <p className="text-[13px] text-foreground-400 mt-1.5 tracking-[0.03em]">
              {t('apply.altContact.email.hours')}
            </p>
          </div>
        </div>

        <p className="text-center text-[13px] text-foreground-400 mt-6 tracking-[0.03em]">
          {t('apply.altContact.note')}
        </p>
      </div>
    </section>
  );
}
